export const translation = {
  zenit: {
    ru: {
      rules: 'Правила',
      download: 'Скачать приложение',
      title: '100% на первый депозит',
      subtitle: 'фрибет до 35 000 ₽',
      reg: 'РЕГИСТРИРУЙСЯ',
      pay: 'ПОПОЛНЯЙ БАЛАНС',
      bonus: 'ПОЛУЧАЙ БОНУС',
      copyright1: '1998 – 2023 Букмекерская контора «‎Зенит»‎',
      copyright2: '© Все права защищены',
      qr: 'Отсканируйте QR код',
      subtitleCasino: '+ 50 Free Spins',
      tel: 'Служба поддержки: 8 800 222 22 12'
    },
    kz: {
      rules: 'Ережелер',
      download: 'Қолданбаны жүктеп алу',
      title: 'салым бойынша 100%',
      subtitle: '195 000.00 тенге дейін тегін ставка',
      reg: 'ТІРКЕЛУ',
      pay: 'БАЛАНСЫҢЫЗДЫ ТОЛТЫРУ',
      bonus: 'БОНУС АЛУ',
      copyright1: '1998 – 2023 букмекерлік компания «‎Зенит»‎',
      copyright2: '© Барлық құқықтар сақталға',
      qr: 'QR кодын сканерлеңіз',
      subtitleCasino: '+ 50 Free Spins',
      tel: 'Қолдау қызметі: 8 800 222 22 12',
    },
    en: {
      rules: 'RULES',
      download: 'Download the app',
      title: '+100% ON DEPOSIT',
      subtitle: 'FREE BET UP TO $430',
      reg: 'REGISTER',
      pay: 'MAKE A DEPOSIT',
      bonus: 'GET A BONUS',
      copyright1: '1998 – 2023 ZENIT BETTING COMPANY',
      copyright2: '© ALL RIGHTS RESERVED',
      qr: 'Scan QR code',
      subtitleCasino: '+ 50 Free Spins',
      tel: 'Support: 8 800 222 22 12'
    },
    uz: {
      rules: 'QOIDALAR',
      download: 'Ilovani yuklab olish',
      title: '+100% DEPOZITGA',
      subtitle: 'FRIBET 6 300 000 UZS GACHA',
      reg: "RO'YXATDAN O'TING",
      pay: "BALANSNI TO'LDIRING",
      bonus: 'BONUS OLING',
      copyright1: '1998 – 2023 BUKMEKER KONTORASI "ZENIT"',
      copyright2: '© BARCHA HUQUQLAR HIMOYALANGAN',
      qr: "QR kodni skanerlash",
      subtitleCasino: '+ 50 Free Spins',
      tel: "Qo'llab-quvvatlash xizmati 8 800 222 22 12",
    },
  },
}
